import { useRef } from 'react';
import { Box, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField';
import { VariableChips, insertAtCursor } from './variable-chips';

export { VariableChips, insertAtCursor, loadVariables } from './variable-chips';
export { fillLeadVariables } from './fill-lead-variables';

type Props = Omit<TextFieldProps, 'onChange'> & {
    value: string;
    onChange: (value: string) => void;
    variableSize?: 'small' | 'large';
};

/// Campo de mensagem com variáveis à mão: errar a chave não avisa e ela iria literal ao cliente.
export const MessageField = ({ value, onChange, variableSize, ...rest }: Props) => {
    const inputRef = useRef<HTMLTextAreaElement | HTMLInputElement | null>(null);

    return (
        <Box>
            <TextField
                {...rest}
                inputRef={inputRef}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />

            <VariableChips
                size={variableSize}
                onInsert={(key) => onChange(insertAtCursor(inputRef.current, value, key))}
            />
        </Box>
    );
};
